import { castArray } from 'lodash-es';
import React, { type ReactNode } from 'react';

import Icon from '../Icon';
import { Message, MessageBox, StyledPageError } from './Styles';

export interface PageErrorProps {
  message: string | string[] | ReactNode;
}

export const PageError: React.FC<PageErrorProps> = ({ message }) => {
  const hasMultipleMessages = Array.isArray(message) && message.length > 1;
  const messageArr = castArray(message);

  return (
    <StyledPageError data-cy-page-error>
      <MessageBox>
        {messageArr.map((text, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Message key={i} isOnlyMessage={!hasMultipleMessages}>
            <Icon type="alert" size={24} />
            <span data-testid="message">{text}</span>
          </Message>
        ))}
      </MessageBox>
    </StyledPageError>
  );
};
